import React, { useState, useEffect } from "react";
import axios from "axios";
import '../styles/patientappoinment.css';


export default function PatientAppointment() {
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [selectedDoctor, setSelectedDoctor] = useState("");
  const [specialization, setSpecialization] = useState("OPD");
  const [currentScreen, setCurrentScreen] = useState(0); // Start at login screen
  const [appointmentDetails, setAppointmentDetails] = useState([]);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [MAD_FULL_NAME, setFullName] = useState("");
  const [MAD_CONTACT, setContact] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  // Handle user login
  const handleLogin = async () => {
    try {
      // Send the POST request with email and password in the request body
      const response = await axios.post(`https://localhost:7132/api/AppoinmentLogin/Login`, {
        email: email,
        password: password,
      });
  
      // Log the response data and show success message
      console.log(response.data);
  
      alert("Login successful");
  
      // Update the screen after successful login
      setCurrentScreen(1);
  
    } catch (error) {
      // Handle any errors
      console.error(error);
      alert("Login failed. Please try again.");
    }
  };
  

  const handleSearch = async (e) => {
    const searchValue = e.target.value;
    setQuery(searchValue);

    if (searchValue.length > 2) {
      try {
        const response = await axios.get(
          `https://localhost:7132/api/User/suggest?query=${searchValue}`
        );
        setSuggestions(response.data);
      } catch (error) {
        console.error("Error fetching suggestions:", error);
        setSuggestions([]);
      }
    } else {
      setSuggestions([]);
    }
  };

  useEffect(() => {
    const fetchAppointments = async () => {
      if (selectedDoctor) {
        try {
          const response = await axios.get(`https://localhost:7132/api/Timeslot/Doctor/${selectedDoctor}`);
          setAppointmentDetails(response.data);
        } catch (error) {
          console.error("Error fetching appointments:", error);
          setAppointmentDetails([]);
        }
      }
    };

    fetchAppointments();
  }, [selectedDoctor]);

  const handleSuggestionClick = (doctorName) => {
    setSelectedDoctor(doctorName);
    setQuery(doctorName);
    setSuggestions([]);
  };

  const handleConfirm = async () => {
    if (!MAD_FULL_NAME || !MAD_CONTACT) {
      alert("Please enter both name and contact details.");
      return;
    }
    try {
      await submitAppointment();
      await handleUpdate();
    } catch (error) {
      console.error(error);
    }
  };

  const handleSearchClick = () => {
    setCurrentScreen(2);
  };

  const handleChannelClick = () => {
    setCurrentScreen(3);
  };

  const handleBookNowClick = (appointment) => {
    setSelectedAppointment(appointment);
    setCurrentScreen(4);
  };

  const handleUpdate = async () => {
    try {
      await axios.patch(`https://localhost:7132/api/Timeslot/${selectedAppointment.MT_SLOT_ID}/incrementSeat`);
    } catch (error) {
      console.error("Failed to update time slot", error.response?.data || error.message);
    }
  };

  const submitAppointment = async () => {
    try {
      const appointmentData = {
        MAD_FULL_NAME,
        MAD_CONTACT,
        MAD_PATIENT_NO: selectedAppointment.MT_PATIENT_NO + 1,
        MAD_APPOINMENT_DATE: selectedAppointment.MT_SLOT_DATE,
        MAD_START_TIME: selectedAppointment.MT_START_TIME,
        MAD_END_TIME: selectedAppointment.MT_END_TIME,
        MAD_DOCTOR: selectedAppointment.MT_DOCTOR,
      };

      await axios.post("https://localhost:7132/api/Appointment", appointmentData);
      alert("Appointment submitted successfully");
      setCurrentScreen(5); // Go to confirmation screen
    } catch (error) {
      console.error("Error booking appointment:", error);
    }
  };

  return (
    <div className="appoinment-screen-container">
      {/* Login Screen */}
      <div className={`screen login-screen ${currentScreen === 0 ? 'active' : ''}`}>
        <h1>Login</h1>
        <label>Email</label>
        <input
          type="text"
          placeholder="please enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <label>Password</label>
        <input
          type="password"
          placeholder="Enter your password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button onClick={handleLogin}>Login</button>
        <p>Don't have an account? <a href="/register-user">Create One</a></p>

      </div>

      {/* Screen 1: Search for Doctor */}
      <div className={`screen1 ${currentScreen === 1 ? 'active' : ''}`}>
        <h1>Find a doctor and book an appointment</h1>
        <label>Doctor name</label>
        <input
          type="search"
          placeholder="Enter doctor name"
          value={query}
          onChange={handleSearch}
        />
        <br />
        {/* Display suggestions */}
        {suggestions.length > 0 && (
          <ul className="doctor-suggestions">
            {suggestions.map((doctorName, index) => (
              <li key={index} onClick={() => handleSuggestionClick(doctorName)}>
                {doctorName}
              </li>
            ))}
          </ul>
        )}
        <label>Any specializations</label>
        <select
          value={specialization}
          onChange={(e) => setSpecialization(e.target.value)}
        >
          <option value="OPD">OPD</option>
          <option value="Psychiatrist">Psychiatrist</option>
          <option value="Dentist">Dentist</option>
        </select>
        <br />
        <button className="btn-search-appointment" onClick={handleSearchClick}>Search</button>
      </div>

      {/* Screen 2: Doctor Details */}
      <div className={`screen2 ${currentScreen === 2 ? 'active' : ''}`}>
        {selectedDoctor && (
          <>
            <p>Doctor Name: {selectedDoctor}</p>
            <p>Specialization: {specialization}</p>
            <button onClick={handleChannelClick}>Channel</button>
          </>
        )}
      </div>

      {/* Screen 3: Appointment Selection */}
      <div className={`screen3 ${currentScreen === 3 ? 'active' : ''}`}>
        <div>
          {appointmentDetails.length > 0 ? (
            <ul>
              {appointmentDetails.map((appointment, index) => (
                <li key={index}>
                  <p>Appointment Date: {new Date(appointment.MT_SLOT_DATE).toLocaleDateString()}</p>
                  <p>
                    Time duration: {new Date(`1970-01-01T${appointment.MT_START_TIME}`).toLocaleTimeString('en-LK', {
                      timeZone: 'Asia/Colombo',
                      hour: 'numeric',
                      minute: 'numeric',
                      hour12: true,
                    })} -{" "}
                    {new Date(`1970-01-01T${appointment.MT_END_TIME}`).toLocaleTimeString('en-LK', {
                      timeZone: 'Asia/Colombo',
                      hour: 'numeric',
                      minute: 'numeric',
                      hour12: true,
                    })}
                  </p>
                  <button onClick={() => handleBookNowClick(appointment)}>Book now</button>
                </li>
              ))}
            </ul>
          ) : (
            <p>No appointments available.</p>
          )}
        </div>
      </div>

      {/* Screen 4: Appointment Confirmation */}
      <div className={`screen4 ${currentScreen === 4 ? 'active' : ''}`}>
        {selectedAppointment && (
          <>
            <p>Your patient number is {selectedAppointment.MT_PATIENT_NO + 1}</p>
            <label>Patient full name</label>
            <input
              type="text"
              placeholder="Enter your full name"
              value={MAD_FULL_NAME}
              onChange={(e) => setFullName(e.target.value)}
            />
            <br />
            <label>Contact</label>
            <input
              type="text"
              placeholder="Enter contact number"
              value={MAD_CONTACT}
              onChange={(e) => setContact(e.target.value)}
            />
            <p>Appointment Date: {new Date(selectedAppointment.MT_SLOT_DATE).toLocaleDateString()}</p>
            <p>
              Time duration: {new Date(`1970-01-01T${selectedAppointment.MT_START_TIME}`).toLocaleTimeString('en-LK', {
                timeZone: 'Asia/Colombo',
                hour: 'numeric',
                minute: 'numeric',
                hour12: true,
              })} -{" "}
              {new Date(`1970-01-01T${selectedAppointment.MT_END_TIME}`).toLocaleTimeString('en-LK', {
                timeZone: 'Asia/Colombo',
                hour: 'numeric',
                minute: 'numeric',
                hour12: true,
              })}
            </p>
            <button onClick={handleConfirm}>Book now</button>
          </>
        )}
      </div>

      {/* Screen 5: Confirmation Message */}
      <div className={`screen5 ${currentScreen === 5 ? 'active' : ''}`}>
        <h1>Thank you for your booking!</h1>
        <p>Your appointment has been successfully booked.</p>
      </div>
    </div>
  );
}
